import { Table } from 'antd';
import { t } from 'i18next';

import { TimePrice, TimesPrice } from '../types';
import { transformTimesPriceToTable } from '../utils/transformer';

interface Props {
  dataSource: TimesPrice;
}

export function TimesPriceRow({ dataSource }: Props) {
  return (
    <Table pagination={false} dataSource={transformTimesPriceToTable(dataSource)}>
      <Table.Column
        width={400}
        title={t('table.time')}
        render={({ startTime, endTime }: TimePrice) => `${startTime}:00-${endTime}:00`}
      />
      <Table.Column
        title={t('table.price')}
        dataIndex={['price']}
        render={(price: number) => `${price }₽`}
      />
    </Table>
  );
}

